import template from './communication-tool-collection.template.html';
import controller from './communication-tool-collection.controller';
import './communication-tool-collection.scss';

export default {
  template,
  controller,
};



// WEBPACK FOOTER //
// ./src/app/communication-tool/communication-tool-collection/communication-tool-collection.component.js